"use client";

import { useEffect, useRef } from "react";
import { useContent } from "../../content/current";

const SECONDS_PER_LOGO = 1;

const CLIENT_LOGO_SOURCES = [
  { src: "/clients/PhotoILike.webp", alt: "PhotoILike" },
  { src: "/clients/nunky.webp", alt: "Nunky" },
  { src: "/clients/proaproptech.webp", alt: "Proa Proptech" },
  { src: "/clients/zanna.webp", alt: "Zanna" },
  { src: "/clients/azurally.webp", alt: "Azurally" },
  { src: "/clients/ecovis.webp", alt: "Ecovis" },
  { src: "/clients/sophiq.webp", alt: "Sophiq" },
  { src: "/clients/tranquiler.webp", alt: "Tranquiler" },
  { src: "/clients/dayde.webp", alt: "Dayde" },
  { src: "/clients/lafabricadesubvenciones.svg", alt: "La Fábrica de Subvenciones" },
];

const half = Math.ceil(CLIENT_LOGO_SOURCES.length / 2);
const ROW1_SOURCES = CLIENT_LOGO_SOURCES.slice(0, half);
const ROW2_SOURCES = CLIENT_LOGO_SOURCES.slice(half);

function makeRow(sources) {
  return Array.from({ length: sources.length * 3 }, (_, index) => {
    const logo = sources[index % sources.length];
    return { id: `${logo.alt}-${index}`, src: logo.src, alt: logo.alt };
  });
}

const LOGOS_ROW1 = makeRow(ROW1_SOURCES);
const LOGOS_ROW2 = makeRow(ROW2_SOURCES);

function applyHover(img, on) {
  img.style.filter = on ? "grayscale(0)" : "grayscale(1)";
  img.style.opacity = on ? "1" : "0.6";
}

export default function LogoCarousel() {
  const content = useContent();
  const duration = `${LOGOS_ROW1.length * SECONDS_PER_LOGO}s`;
  const wrapRef = useRef(null);

  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return;

    let mouseX = -1,
      mouseY = -1;
    let activeImg = null;
    let raf;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };
    const onLeave = () => {
      mouseX = -1;
      mouseY = -1;
    };

    function tick() {
      let nextImg = null;

      if (mouseX >= 0) {
        const wrapRect = wrap.getBoundingClientRect();
        const inside =
          mouseX >= wrapRect.left &&
          mouseX <= wrapRect.right &&
          mouseY >= wrapRect.top &&
          mouseY <= wrapRect.bottom;

        if (inside) {
          const el = document.elementFromPoint(mouseX, mouseY);
          const cliente = el?.closest(".cliente");
          if (cliente && wrap.contains(cliente)) {
            nextImg = cliente.querySelector("img");
          }
        }
      }

      if (nextImg !== activeImg) {
        if (activeImg) applyHover(activeImg, false);
        activeImg = nextImg;
        if (activeImg) applyHover(activeImg, true);
      }

      raf = requestAnimationFrame(tick);
    }

    raf = requestAnimationFrame(tick);
    wrap.addEventListener("mousemove", onMove);
    wrap.addEventListener("mouseleave", onLeave);

    return () => {
      cancelAnimationFrame(raf);
      wrap.removeEventListener("mousemove", onMove);
      wrap.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  return (
    <div id="logos" ref={wrapRef} style={{ "--carousel-duration": duration }}>
      <h4>{content.logos.title}</h4>
      <div id="logos1">
        {LOGOS_ROW1.map((logo) => (
          <div key={`logos1-${logo.id}`} className="cliente">
            <img src={logo.src} alt={logo.alt} decoding="async" />
          </div>
        ))}
      </div>
      <div id="logos2">
        {LOGOS_ROW2.map((logo) => (
          <div key={`logos2-${logo.id}`} className="cliente">
            <img src={logo.src} alt={logo.alt} decoding="async" />
          </div>
        ))}
      </div>
    </div>
  );
}
